import { render, staticRenderFns } from "./CdiOption.vue?vue&type=template&id=ece963ec&scoped=true"
import script from "./CdiOption.vue?vue&type=script&lang=js"
export * from "./CdiOption.vue?vue&type=script&lang=js"
import style0 from "./CdiOption.vue?vue&type=style&index=0&id=ece963ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece963ec",
  null
  
)

export default component.exports